import { openChat } from 'helpers/supportChat';
import { SettingsIllustration } from './components/settingsIllustration';
import { CompletedIllustration } from './components/completedIllustration';
import { InProgressIllustration } from './components/inProgressIllustration';

const notStarted = {
  label: 'Not started',
  color: 'text.subtle',
  bg: 'neutral.50',
  icon: SettingsIllustration,
  title: 'We’re setting up your campaign',
  description: ['We’ll let you know when it’s launched.'],
  infoTitle: 'We’re setting up your campaign',
  info: 'We’re setting things up for you. The Agent will start reaching out soon. You’ll get an email once the campaign begins.',
};

export const statuses = {
  active: {
    label: 'Active',
    color: 'blue.600',
    bg: 'blue.50',
    icon: InProgressIllustration,
    title: 'The Agent is reaching out to candidates',
    description: [
      'Candidates who click “Apply” will show here. Expect first results after a few days of launching the campaign.',
    ],
    infoTitle: 'The Agent is reaching out to candidates',
    info: 'The Agent is actively finding and emailing qualified candidates. Outreach happens in batches to ensure strong deliverability. Most campaigns complete in about 10 days.',
  },
  paused: {
    label: 'Completed',
    color: 'green.600',
    bg: 'green.20',
    icon: CompletedIllustration,
    title: 'Campaign completed — no clicks yet',
    description: [
      'The Agent has finished outreach, but none have clicked “Apply” yet.',
      'This campaign is on us — we’d love to help you refine your search and create a new one that delivers better results.',
    ],
    infoTitle: 'All qualified candidates have been emailed',
    info: 'Outreach for this campaign is complete. Candidates may still click “Apply” from previously sent emails, so results can continue to update for a few more days.',
    action: {
      text: "Let's talk",
      onClick: () => openChat(null, { name: 'Sourcing Agent' }),
    },
  },
  not_started: notStarted,
  unknown: {
    ...notStarted,
    label: 'Not started',
    color: 'text.subtle',
    bg: 'neutral.50',
  },
  campaignIssue: {
    ...notStarted,
    label: 'Campaign Issue',
    color: 'orange.50',
    bg: 'orange.600',
  },
};
